import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Header,
  Modal,
} from 'semantic-ui-react';

import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
import MediaList from '../../components/MediaList';
import UploadModal from '../../components/UploadModal';
import ViewLarge from './ViewLarge';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import { DEFAULT_PROMPT } from '../../constants/promptMessages';

import Form from '../Videos/Form';

class AddMedia extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onCreate: PropTypes.func,
    onCheck: PropTypes.func,
    t: PropTypes.func,
    type: PropTypes.oneOf(['project', 'unit_layout']).isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      showLarge: false,
      showAdd: false,
      selectedMedia: null,
      uploadModalState: false,
    };
  }
  fixBody = () => {
    const anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal.length > 0) {
      document.body.classList.add('dimmable', 'dimmed');
    }
  }
  handleRefetch = () => {
    if (this.mediaList) {
      this.mediaList.getWrappedInstance().handleRefetch();
    }
  }
  handleViewLarge = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({ selectedMedia }, () => {
      this.setState({
        showLarge: true,
      });
    });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedMedia: null,
    });
  }
  handleAddPicture = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, this.state.selectedMedia);
    }
    this.setState({
      selectedMedia: null,
      showAdd: false,
    }, () => {
      this.fixBody();
    });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  checkAdded = (data) => {
    if (this.props.onCheck) {
      return this.props.onCheck(data);
    }
    return false;
  }
  handleOnCreate = (validations, media) => {
    if (this.props.onCreate) {
      const { url, options } = this.props.onCreate(media);
      if (url && options) {
        this.createMedia(url, options, validations);
      }
    }
  }
  createMedia = async (url, options, validations) => {
    const { t } = this.props;
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    try {
      await this.form.submit(url, options);
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ uploadModalState: false });
    this.handleRefetch();
    store.dispatch(flashSuccessMessage({ header: t('Create Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully created', { ns: TRANSLATION_FILES.translation }) }));
  }
  handleShowAdd = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      showAdd: true,
      selectedMedia,
    });
  }
  handleCancelAdd = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAdd: false,
      selectedMedia: null,
    }, () => {
      this.fixBody();
    });
  }
  handleCheckBeforeClose = () => {
    const { t } = this.props;
    if (this.form && this.form.state && this.form.state.hasChanges) {
      const callback = () => {
        this.setState({ uploadModalState: false });
        this.handleRefetch();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(DEFAULT_PROMPT, { ns: TRANSLATION_FILES.translation }), callback }));
      return true;
    }
    return false;
  }
  handleUploadModalStateChange = (open) => {
    this.setState({ uploadModalState: open });
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        className="add-picture"
        open={this.props.open}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
      >
        <Header icon="image outline" content={t('Add videos', { ns: TRANSLATION_FILES.translation })} />
        <Modal.Content scrolling>
          <Grid verticalAlign="middle" columns="equal">
            <Grid.Row>
              <Grid.Column>
                <ViewLarge
                  open={this.state.showLarge}
                  onClose={this.handleCloseLarge}
                  picture={this.state.selectedMedia}
                  type="video"
                />
                <MediaList
                  ref={(ref) => { this.mediaList = ref; }}
                  toggleable
                  onViewLarge={this.handleViewLarge}
                  onRemove={this.handleRemove}
                  buttonNode={({ view, loading, item }) => (
                    <Button
                      compact size="small"
                      attached={view === 'card' ? 'bottom' : null}
                      primary={!this.checkAdded(item)}
                      positive={this.checkAdded(item)}
                      icon={this.checkAdded(item) ? 'checkmark' : 'add'}
                      content={this.checkAdded(item) ? t('Added', { ns: TRANSLATION_FILES.translation }) : t('Add', { ns: TRANSLATION_FILES.translation })}
                      disabled={this.checkAdded(item) || loading}
                      onClick={e => this.handleShowAdd(e, item)}
                    />
                  )}
                  searchRightNav={
                    this.props.onCreate ? (
                      <UploadModal
                        modalState={this.state.uploadModalState}
                        floated="right"
                        header="video"
                        icon={null}
                        btnText={t('New', { ns: TRANSLATION_FILES.screens })}
                        onModalStateChange={this.handleUploadModalStateChange}
                        onClose={this.handleCheckBeforeClose}
                        content={() => (
                          <Form
                            ref={(ref) => { this.form = ref; }}
                            onSubmit={this.handleOnCreate}
                          />
                        )}
                      />
                    ) : null
                  }
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Modal
            open={this.state.showAdd}
            onClose={this.handleCancelAdd}
            closeIcon="close"
            size="large"
          >
            <Header icon="add" content={` ${t('Add video to', { ns: TRANSLATION_FILES.translation })} ${this.props.type.replace('_', ' ')}`} />
            <Modal.Content scrolling>
              <Grid columns="equal" stackable doubling textAlign="center">
                <Grid.Column>
                  {
                    this.state.selectedMedia && this.state.selectedMedia.data && (
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: this.state.selectedMedia.data.html,
                        }}
                      />
                    )
                  }
                </Grid.Column>
              </Grid>
            </Modal.Content>
            <Modal.Actions>
              <Button basic negative onClick={this.handleCancelAdd} icon="cancel" content={t('Cancel', { ns: TRANSLATION_FILES.screens })} inverted />
              <Button basic positive onClick={this.handleAddPicture} icon="add" content={t('Add', { ns: TRANSLATION_FILES.screens })} inverted />
            </Modal.Actions>
          </Modal>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(AddMedia);



// WEBPACK FOOTER //
// ./src/containers/modals/AddMedia.jsx